import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CookieHandler } from 'utils'
import { Icon } from 'ui/atoms'

export default function CookieBanner({ accepted, duration, text, moreInformation, onAccept }) {
  const [clickedAccept, setClickedAccept] = useState(false)

  const accept = () => {
    CookieHandler.setCookie('cookie-accepted', 1, duration)
    setClickedAccept(true)
    onAccept && onAccept()
  }

  if (clickedAccept || accepted) return null
  return (
    <div className="cookie-banner">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="cookie-banner__button" onClick={accept}>
              <Icon className="icon--small" name="close" title="Schließen" />
            </div>
            <div className="cookie-banner__text">
              <div>
                <span>{text}&nbsp;</span>
                {moreInformation && (
                  <a
                    className="cookie-banner__link"
                    rel="noopener noreferrer"
                    href={moreInformation.href}
                    target="_blank"
                  >
                    <span className="link__text">
                      <span>{moreInformation.text}</span>
                    </span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CookieBanner.propTypes = {
  accepted: PropTypes.bool,
  duration: PropTypes.number,
  text: PropTypes.string.isRequired,
  moreInformation: PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }),
  onAccept: PropTypes.func
}

CookieBanner.defaultProps = {
  accepted: !!CookieHandler.getCookie('cookie-accepted')
}
